import { IconButton, Tooltip } from '@wix/design-system';
import { SearchCodeSmall as SearchCodeSmallIcon } from '@wix/wix-ui-icons-common';
import React from 'react';
import { useTranslation } from '../../hooks';
export const ViewDetailsIcon = _ref => {
  let {
    onViewDetails
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: t('view-details.tooltip'),
    interactive: false,
    enterDelay: 200
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "tiny",
    style: {
      display: 'block'
    },
    priority: "tertiary",
    onClick: onViewDetails
  }, /*#__PURE__*/React.createElement(SearchCodeSmallIcon, {
    style: {
      display: 'block'
    }
  })));
};
//# sourceMappingURL=ViewDetailsIcon.js.map